/** Contact phone/email verification UI discriminators. */

export const ContactVerifyChannel = {
  Phone: "phone",
  Email: "email",
} as const;

export type ContactVerifyChannel =
  (typeof ContactVerifyChannel)[keyof typeof ContactVerifyChannel];

export const ContactVerifyUiKind = {
  Idle: "idle",
  Sent: "sent",
} as const;

export type ContactVerifyUiKind =
  (typeof ContactVerifyUiKind)[keyof typeof ContactVerifyUiKind];
